module.exports = __webpack_public_path__ + "static/iron_cobra-e89e6238dc66a67a1bb9ec544d79894e.png";